"use client";
import { Input } from "@nextui-org/input";
import { useRouter } from "next13-progressbar";
import { useState } from "react";
import { IoSearchOutline } from "react-icons/io5";

function SearchBoxNav() {
  const options = [
    { id: 1, label: "Autores" },
    { id: 2, label: "Documentos" },
    { id: 3, label: "Organizaciones" },
    { id: 4, label: "Eventos" },
    { id: 5, label: "Proyectos" },
    { id: 6, label: "Patentes" },
    { id: 7, label: "Servicios" },
  ];

  const [optionSelected, setOptionSelected] = useState(options[0]);
  const [searchInput, setSearchInput] = useState("");
  const router = useRouter();

  function handleInputChange(event) {
    setSearchInput(event.target.value);
  }

  function handleSelectChange(event) {
    const selectedId = parseInt(event.target.value);
    const selectedOption = options.find((option) => option.id === selectedId);
    setOptionSelected(selectedOption);
  }

  function handlePress(event) {
    if (event.key === "Enter") search();
  }

  function search() {
    const url =
      searchInput === ""
        ? `/search?o=${optionSelected.id}`
        : `/search?q=${searchInput}&o=${optionSelected.id}`;

    router.push(url);
    setSearchInput("");
    setOptionSelected(options[0]);
  }

  return (
    <div className="hidden lg:flex lg:w-[800px]">
      <Input
        type="text"
        value={searchInput}
        onChange={handleInputChange}
        placeholder={`Buscar ${optionSelected.label.toLowerCase()}...`}
        labelPlacement="outside"
        onKeyUp={handlePress}
        classNames={{
          input: ["caret-gray-500 h-auto border-none focus:outline-none"],
        }}
        startContent={
          <select
            value={optionSelected.id}
            onChange={handleSelectChange}
            className="bg-gray-100 text-gray-700 py-2 px-4 border-none outline-none rounded-l-full text-sm"
          >
            {options.map((option) => (
              <option key={option.id} value={option.id}>
                {option.label}
              </option>
            ))}
          </select>
        }
        endContent={
          <IoSearchOutline
            className="text-2xl font-bold hover:cursor-pointer text-gray-900 mr-3"
            onClick={search}
          >
            search
          </IoSearchOutline>
        }
      />
    </div>
  );
}

export default SearchBoxNav;
